<template>
  <path
    d="M1.32127 8.94L6.10127 13.72C6.2251 13.844 6.37215 13.9423 6.53401 14.0094C6.69588 14.0765 6.86938 14.1111 7.0446 14.1111C7.21982 14.1111 7.39332 14.0765 7.55519 14.0094C7.71705 13.9423 7.8641 13.844 7.98793 13.72L13.7146 8V1.33334H7.04793L1.32127 7.06C1.07293 7.30982 0.933544 7.64775 0.933544 8C0.933544 8.35225 1.07293 8.69019 1.32127 8.94Z"
    stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
</template>